import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { FormControl } from '@angular/forms';
import { FinanceService } from '../../../core/service/app/finance.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/app-state';

@Component({
  selector: 'app-billing-statement',
  templateUrl: './billing-statement.component.html',
  styleUrls: ['./billing-statement.component.scss']
})
export class BillingStatementComponent extends FormBaseComponent<any> implements OnInit {


  list = [];

  months = [
    'ENERO',
    'FEBRERO',
    'MARZO',
    'ABRIL',
    'MAYO',
    'JUNIO',
    'JULIO',
    'AGOSTO',
    'SEPTIEMBRE',
    'OCTUBRE',
    'NOVIEMBRE',
    'DICIEMBRE',
  ]
  userid = 0;
  loading = false;
  guardando = false;
  listaValida = false;

  @Input() idTpv: number = 0;

  @Output()
  completado: EventEmitter<any> = new EventEmitter<any>();

  constructor(private financeService: FinanceService, private store: Store<AppState>) {
    super();
    if(this.list.length > 0){ this.listaValida = true;}
    
    

    this.store.subscribe(state => {

      if (state && state.user.data) {
        this.userid = state.user.data.id;
        
        if(this.list == [])
        {

          if(this.idTpv)
          {
            this.financeService.getBillingList(this.idTpv)
            .then(data => {
              this.loading = false;
              this.list = data;
              this.completado.emit({ status: this.validaEstadoCuenta(), ids: data.toString(), monto: 0 });
            });

          }
        }
      }
    });
  }

  ngOnInit() {
    this.init();
    this.getList();


    if(this.list.length > 0){ this.listaValida = true;}
    
    if(this.idTpv != 0)
    {
      this.financeService.getBillingList(this.idTpv)
      .then(data => {
        this.list = data;
        this.completado.emit({ status: this.validaEstadoCuenta(), ids: data.toString(), monto: 0 });
      });
    }
    

  }

  template() {
    this.form.addControl('temp', new FormControl());
  }

  getfileid(event, index) {
    if (event) {
      this.list[index].idArchivo = event.id
    }
  }

  titulo(item) {
    return this.months[item.mes - 1] + ' del año ' + item.anio;
  }

  saveall() {
    this.loading = true;
    this.guardando = true;
    this.list.forEach(item => {
      if(item.idTPV == 0){ item.idTPV = this.idTpv; }
    });

    this.financeService.saveAllBilling(this.list)
      .then(result => {
        this.loading = false;
        this.guardando = false;
        

        let monto = 0;
        this.list.map(item => { monto += item.monto })
        monto = monto / this.list.length;
        this.completado.emit({ status: this.validaEstadoCuenta(), ids: result.toString(), monto: Math.round(monto) });
        this.getList();
      })
  }

  getList()
  {
    if(this.idTpv != 0)
    {
      this.financeService.getBillingList(this.idTpv)
      .then(data => {
        this.loading = false;
        this.list = data;
        this.completado.emit({ status: this.validaEstadoCuenta(), ids: data.toString(), monto: 0 });
      });
    }
  }

  validaEstadoCuenta()
  {
    var valid = true;
    this.list.forEach(item => {
      if(item.idArchivo == 0){ valid = false; }
    });
    
    return valid;
  }

}


















// WEBPACK FOOTER //
// ./src/app/form/form/billing-statement/billing-statement.component.ts